import { Injectable } from "@angular/core";
import { UrlControl } from "../models/generic.model";
import { AppSettings } from "../../app.settings";

@Injectable()
export class UrlService {
  public hostAPI_ACCVIS: string;
  public hostAPI_UAC: string;
  public hostAPI_FUNCIONARIOS: string;
  public hostAPI_TRANS = AppSettings.API_INIT_ENDPOINT;
  public API_WEBSOCKET_TURNOS: string;
  public hostAPI_CARGUE_MASIVO: string;

  constructor() {
    this.refrescar();
  }

  refrescar() {
    this.hostAPI_UAC = sessionStorage.getItem("hostAPI_UAC");
    this.hostAPI_ACCVIS = sessionStorage.getItem("hostAPI_ACCVIS");
    this.hostAPI_FUNCIONARIOS = sessionStorage.getItem("hostAPI_FUNCIONARIOS");
    this.API_WEBSOCKET_TURNOS = sessionStorage.getItem("API_WEBSOCKET_TURNOS");
	this.hostAPI_CARGUE_MASIVO = sessionStorage.getItem("hostAPI_CARGUE_MASIVO");
  }

  /**
   * Cambia el valor del API CARGUE MASIVO de archivos de Excel a base de datos
   * @author jperea
   * @param API
   */
  setApiCargueMasivo(API) {
    this.hostAPI_CARGUE_MASIVO = API;
    sessionStorage.setItem("hostAPI_CARGUE_MASIVO", API);
  }
  /**
   * Cambia el valor del API WEBSOCKET de turnos según parámetro de entrada
   * @author fromero
   * @param API
   */
  setApiWebSocketTurnos(API) {
    this.API_WEBSOCKET_TURNOS = API;
    sessionStorage.setItem("API_WEBSOCKET_TURNOS", API);
  }
  /**
   * cambia el valor del API de ACVIS según parámetro de entrada
   * @param API
   * @author fromero
   */
  setApiAcvis(API) {
    this.hostAPI_ACCVIS = API;
    sessionStorage.setItem("hostAPI_ACCVIS", API);
  }
  /**
   * cambia el valor del API de UAC según parámetro de entrada
   * @param API
   * @author fromero
   */
  setApiUac(API) {
    this.hostAPI_UAC = API;
    sessionStorage.setItem("hostAPI_UAC", API);
  }
  /**
   * cambia el valor del API de FUNCIONARIOS según parámetro de entrada
   * @param API
   * @author fromero
   */
  setApiFuncionarios(API) {
    this.hostAPI_FUNCIONARIOS = API;
    sessionStorage.setItem("hostAPI_FUNCIONARIOS", API);
  }

  /**
   * arma las url de ACCVIS
   * @param control obteto con el que se contruye la url
   * @param host acceso a la aplicación a utilizar para el consumo
   */
  getUrl(control: UrlControl, host: string): string {
    const provider = this.getProvider(control.serviceProvider);
    return this.formarUtl(control, host, provider);
  }

  /**
   * arma las URL de UAC
   * @param control obteto con el que se contruye la url
   * @param host acceso a la aplicación a utilizar para el consumo
   */
  getUrlUAC(control: UrlControl, host: string): string {
    const provider = this.getProviderUAC(control.serviceProvider);
    return this.formarUtl(control, host, provider);
  }

  /**
   * arma las URL funcionario
   * @param control obteto con el que se contruye la url
   * @param host acceso a la aplicación a utilizar para el consumo
   */
  getUrlFuncionario(control: UrlControl, host: string): string {
    const provider = this.getProviderFuncionario(control.serviceProvider);
    return this.formarUtl(control, host, provider);
  }

  /**
   * arma las URL transversales
   * @param control obteto con el que se contruye la url
   * @param host acceso a la aplicación a utilizar para el consumo
   */
  getUrlTransversal(control: UrlControl, host: string): string {
    const provider = this.getProviderTransversal(control.serviceProvider);
    return this.formarUtl(control, host, provider);
  }

  /**
   * Concatena los parametros de entrada para formar una url
   * @param control
   * @param host
   * @param provider
   */
  private formarUtl(control: UrlControl, host: string, provider: string) {
    let url = host + provider;
    if (control.pathParameters != null) {
      const path = this.getPathParams(control.pathParameters);
      url = url + path;
    }
    if (control.queryParameters != null) {
      const query = this.getQueryParams(control.queryParameters);
      url = url + query;
    }
    return url;
  }

  /**
   * provider para los servicios de ACCVIS
   * @param serviceProvider servicio a consumir
   */
  private getProvider(serviceProvider: string): string {
    switch (serviceProvider) {
      case "CargueList":
        return "/cargue/all";
      case "LogList":
        return "/cargue/log";
      case "CargueExcel":
        return "/cargue/import";
      case "CargueLogErrores":
        return "/cargue/errores";
      case "CargueLogErroresExport":
        return "/cargue/errores/export";
      case "InitAplication":
        return "/servicio/init/consultarEndPoint";
      case "ValidarCodigoTalanquera":
        return "/servicios/codigos/validarEstadoCodigoTalanquera";
      case "validarEstadoCodigo":
        return "/servicios/codigos/validarEstadoCodigo";
      case "Init":
        return "/servicio/init";
      case "Version":
        return "/servicio/init/version";
      case "ObtenerToken":
        return "/seguridad-apiRest/recursoswebseguridad/servicios/autenticacion/obtenertoken";
      case "ObtenerPermisosRol":
        return "/seguridad-apiRest/recursoswebseguridad/servicios/autenticacion/obtenerrolespermisos";
      case "getDiscapacidad":
        return "/servicios/grupodiscapacidad";
      case "ObtenerFuncionario":
        return "/servicios/funcionario";
      case "ObtenerDependencias":
        return "/servicios/dependencia";
      case "ObtenerDominio":
        return "/servicios/detalledominio";
      case "ObtenerGrupoDiscapacidad":
        return "/servicios/grupodiscapacidad/consultaDiscapacidadFiltros";
      case "getTipoIdentificacion":
        return "/servicios/detalledominio?filterBy=detalleDominioPK.nombreDominio%3ALIKE%3ATipoIdentificacion";
      case "getMotivoIngresoComo":
        return "/servicios/detalledominio?filterBy=detalleDominioPK.nombreDominio=Vinculacion";
      case "getRh":
        return "/servicios/detalledominio?filterBy=detalleDominioPK.nombreDominio=Rh";
	  case "ObtenerTipoVehiculo":
        return "/servicios/detalledominio?filterBy=detalleDominioPK.nombreDominio%3ALIKE%3ATipoVehiculo";
      case "GuardarAgendaVisitante":
        return "/servicios/agenda/registroAgenda";
      case "GuardarGrupoFuncionariosDiscapacidad":
        return "/servicios/funcionario/actualizarFuncionario";
      case "ObetenerInformacionAgendasVisitante":
        return "/servicios/agenda/consultaInformacionVisitante";
      case "ObtenerAgendaVisitante":
        return "/servicios/agenda";
      case "ObtenerVisitante":
        return "/servicios/visitante";
      case "RegistrarSalidaVisitante":
        return "/servicios/agenda/registrarSalidaVisitante";
      case "RegistrarIngresoVisitante":
        return "/servicios/agenda/registrarIngresoVisitante";
      case "ConsultaAgendasDia":
        return "/servicios/agenda/consultaVisitaAgendada";
      case "ConsultaActivoFijo":
        return "/servicios/activofijovisitante";
      case "cancelarAgenda":
        return "/servicios/agenda/cancelarAgenda";
      case "Funcionario":
        return "/servicios/funcionario/registros";
      case "MarcasActivoFijo":
        return "/servicios/activofijo/marca";
      case "RegistroActivoFijo":
        return "/servicios/regingsalactivofijo";
      case "ValidarAgenda":
        return "/servicios/agenda/validarAgenda";
      case "ObtenerIngresoSalidaActivosFijo":
        return "/servicios/activofijo/ObtenerIngresoSalidaActivosFijo";
      case "ObtenerActivoFijoFuncionario":
        return "/servicios/activofijo/ObtenerActivoFijoFuncionario";
      case "ConsultaActivosFijosVisitante":
        return "/servicios/activofijovisitante/consultaActivoFijo";
      case "registrarActivoFijoVisitante":
        return "/servicios/activofijovisitante/registrarActualizarActivoFijo";
      case "RegistrarSalidaActivoFijoFuncionario":
        return "/servicios/activofijo/RegistrarSalidaActivoFijoFuncionario";
      case "RegistrarIngresoActivoFijoFuncionario":
        return "/servicios/activofijo/RegistrarIngresoActivoFijoFuncionario";
      case "CrearActivoFijoFuncionario":
        return "/servicios/activofijo/CrearActivoFijoFuncionario";
      case "reporteActivosFijos":
        return "/servicios/reportes/reportesActivoFijo";
      case "reporteInformeVisitante":
        return "/servicios/reportes/reportesInformeVisitante";
      case "reporteMedevac":
        return "/servicios/reportes/reporteMedevac";
      case "ObtenerTipoActivoFijo":
        return "/servicios/activofijo/ObtenerTipoActivoFijo";
      case "ObtenerDescripcionActivoFijo":
        return "/servicios/activofijo/ObtenerDescripcionActivoFijo";
      case "ObtenerTipoFuncionario":
        return "/servicios/funcionario/ObtenerTipoFuncionario";
      case "reporteTotalIngresos":
        return "/servicios/reportes/reporteTotalIngresos";
      case "consultaNombreArchivo":
        return "/servicios/agenda/consultarArchivosCargaMasiva";
      case "consultaAgendasArchivo":
        return "/servicios/agenda/consultarAgendaMasiva";
      case "consultarEstadoCodigoTarjeta":
        return "/servicios/agenda/consultarEstadoCodigoTarjeta";
      case "consultarFucionarioSIA3":
        return "/servicios/funcionario/consultarFucionarioSIA3";
      case "ObtenerParametros":
        return "/servicios/parametros";
      case "retomarVisita":
        return "/servicios/agenda/retomavisita";
      case "RegistrarIngresoVisitanteTarjeta":
        return "/servicios/agenda/RegistrarIngresoVisitanteTarjeta";
      case "consultarCodigosTarjetaStickers":
        return "/servicios/codigos/consultarCodigosAsociadosTarjetaStickers";
      case "ObtenerTarjetasStickers":
        return "/servicios/codigos/ObtenerTarjetasStickers";
      case "consultarActivosPropiosMen":
        return "/servicios/activofijo/consultarActivosPropiosMen";
      case "descargarDocumento":
        return "/servicios/gestorDocumental/descargardocumento";
      case "ConsultarDocumentos":
        return "/servicios/gestorDocumental/consultadocumentos";
      case "consultarFuncionarioAgenda":
        return "/servicios/agenda/consultarFuncionarioAgenda";
      case "crearCodigosStickers":
        return "/servicios/codigos/crearCodigosStickers";
      case "crearCodigosTarjetas":
        return "/servicios/codigos/crearCodigosTarjetas";
      case "editarCodigosTarjetasStickers":
        return "/servicios/codigos/editarCodigosTarjetasStickers";
      case "editarCodigosTarjetasConPDF":
        return "/servicios/codigos/editarCodigosTarjetasConPDF";
      case "consultarInformacionCodigo":
        return "/servicios/codigos/consultarInformacionCodigo";
      case "consultarParametros":
        return "/servicios/parametros/consultarParametros";
      case "asociarFuncionario":
        return "/servicios/funcionario/asociarFuncionario";
      case "codigos":
        return "/servicios/codigos";
      case "editarAgendaIndividual":
        return "/servicios/agenda/editarAgendaIndividual";
      case "consultarDominios":
        return "/servicios/servicios/dominio"; // Transversal
      case "eliminarAgendaMasiva":
        return "/servicios/agenda/eliminarAgendaMasiva";
      case "descargarPlatillaMasiva":
        return "/servicios/gestorDocumental/plantilla";
      default:
        return "";
    }
  }

  /**
   * provider para los servicios de UAC
   * @param serviceProvider servicio a consumir
   */
  private getProviderUAC(serviceProvider: string): string {
    switch (serviceProvider) {
      case "CargueList":
        return "/cargue/all";
      case "CargueExcel":
        return "/cargue/import";
      case "CargueLogErrores":
        return "/cargue/errores";
      case "CargueLogErroresExport":
        return "/cargue/errores/export";
      case "validarEstadoCodigo":
        return "/servicios/codigos/validarEstadoCodigo";
      case "buscarFuncionarioUac":
        return "/servicios/funcionario/buscarFuncionarioUac";
      case "consultarFuncionarioAgenda":
        return "/servicios/agenda/consultarFuncionarioAgenda";
      case "reporteTurnoVirtualUAC":
        return "/servicios/reportes/reporteTurnoVirtualUAC";
      case "obtenerPersonaAgendasVirtuales":
        return "/servicios/agendavirtual/obtenerPersonaAgendasVirtuales";
      case "ObtenerVisitante":
        return "/servicios/visitante";
      case "tramiteUAC":
        return "/servicios/tramiteuac";
      case "turnoUAC":
        return "/servicios/turnouac";
      case "consultaTurnosPorTramite":
        return "/servicios/turnouac/consultaTurnosPorTramite";
      case "llamarTurnoUac":
        return "/servicios/turnouac/llamarTurnoUac";
      case "iniciarAtencionTurno":
        return "/servicios/turnouac/iniciarAtencionTurno";
      case "obtenerConfiguracionVentanilla":
        return "/servicios/ventanillauac/obtenerConfiguracionVentanilla";
      case "consultarTramites":
        return "/servicios/tramiteuac/consultarParametroServicios";
      case "consultarVentanillas":
        return "/servicios/ventanillauac/consultarParametroVentanillas";
      case "crearTramite":
        return "/servicios/tramiteuac";
      case "crearVentanilla":
        return "/servicios/ventanillauac";
      case "actualizarVentanilla":
        return "/servicios/ventanillauac/actualizarParametroVentanilla";
      case "actualizarTramite":
        return "/servicios/tramiteuac/actualizarParametroTramite";
      case "CiudadanoTieneAgenda":
        return "/servicios/agendavirtual/consultaragendaspendientes";
      case "actualizarInfoVisitante":
        return "/servicios/visitante/actualizarInfoVisitante";
      case "servicioServicioFuncionario":
        return "/servicios/serviciofuncionario";
      case "actualizarTramiteVentanilla":
        return "/servicios/configuracionventanilla/actualizarTramiteVentanilla";
      case "abandonarturnoUac":
        return "/servicios/turnouac/abandonarturnoUac";
      case "ObtenerDominio":
        return "/servicios/detalledominio";
      case "ventanillaEspera":
        return "/servicios/ventanillauac/ventanillaEspera";
      case "ObtenerParametros":
        return "/servicios/parametros";
      case "turnoDistraidoUac":
        return "/servicios/turnouac/turnoDistraidoUac";
      case "consultaTurnoPendientesDocs":
        return "/servicios/turnouac/consultaTurnoPendientesDocs";
      case "cancelarAgendaVirtual":
        return "/servicios/agendavirtual/cancelarAgendaVirtual";
      case "solicitudTurno":
        return "/servicios/agendavirtual/solicitudturnovirtual";
      case "validarSolicitudTurno":
        return "/servicios/agendavirtual/validarsolicitudturnovirtual";
      case "finalizarTurnoCiudadano":
        return "/servicios/turnouac/finalizarTurnoCiudadano";
      case "cambiarTramiteTurnoUac":
        return "/servicios/turnouac/cambiarTramiteTurnoUac";
      case "obtenerAgendas":
        return "/servicios/agendavirtual/obteneragendas";
      case "reporteCantiadesTabla":
        return "/servicios/turnouac/reporteCantiadesTabla";
      case "reporteCantiades":
        return "/servicios/reportes/reporteCantiades";
      case "turnosPorTramite":
        return "/servicios/tableroDeControl/turnosPorTramite";
      case "consultarAgendaVigente":
        return "/servicios/agendavirtual/consultarAgendaVigente";
      case "generarTurno":
        return "/servicios/turnouac/generarTurno";
      case "consultaTramiteVentanillaFunc":
        return "/servicios/turnouac/consultaTramiteVentanillaFunc";
      case "turnosPorTramiteReporteExcel":
        return "/servicios/tableroDeControl/turnosPorTramiteReporteExcel";
      case "tiempoPromedioAtencionVentanilla":
        return "/servicios/tableroDeControl/tiempoPromedioAtencionVentanilla";
      case "promedioAtencionVentanillaReporteExcel":
        return "/servicios/tableroDeControl/promedioAtencionVentanillaReporteExcel";
      case "configuracionVentanilla":
        return "/servicios/configuracionventanilla";
      case "guardarConfiguracionVentanilla":
        return "/servicios/configuracionventanilla/guardarConfiguracionVentanilla";
      case "reporteAtenciones":
        return "/servicios/reportes/reporteAtenciones";
      case "reporteAtencionesTabla":
        return "/servicios/turnouac/reporteAtencionesTabla";
      case "reportePorNombreEventoTabla":
        return "/servicios/turnouac/reportePorNombreEventoTabla";
      case "reportePorNombreEvento":
        return "/servicios/reportes/reportePorNombreEvento";
      case "getTurnoActualVentanilla":
        return "/servicios/turnouac/getTurnoActualVentanilla";
      case "tiempoPromedioEsperaTramite":
        return "/servicios/tableroDeControl/tiempoPromedioEsperaTramite";
      case "promedioEsperaTramiteReporteExcel":
        return "/servicios/tableroDeControl/promedioEsperaTramiteReporteExcel";
      case "getFuncionariosRolVentanilla":
        return "/servicios/configuracionventanilla/getFuncionariosRolVentanilla";
      case "getConfiguracionPrevia":
        return "/servicios/configuracionventanilla/getConfiguracionPrevia";
      case "consultaAgendaVirtual":
        return "/servicios/agendavirtual";
      case "actualizarTurnoVirtual":
        return "/servicios/agendavirtual/reprogramaragenda";
      case "consutarTurnoProceso":
        return "/servicios/turnouac/consutarTurnoProceso";
      case "llamarTurnoPendienteDocs":
        return "/servicios/turnouac/llamarTurnoPendienteDocs";
      case "getTipoIdentificacion":
        return "/servicios/detalledominio?filterBy=detalleDominioPK.nombreDominio%3ALIKE%3ATipoIdentificacion";
	  case "getMotivoIngresoComo":
        return "/servicios/detalledominio?filterBy=detalleDominioPK.nombreDominio=Vinculacion";
	  case "getRh":
        return "/servicios/detalledominio?filterBy=detalleDominioPK.nombreDominio=Rh";
      case "consultarConfiguracionFuncionario":
        return "/servicios/configuracionventanilla/consultarConfiguracionFuncionario";
      case "parametroPorNombre":
        return "/servicios/parametros/consultarParametrosPorNombre";
      //consultarParametrosTotem
      case "parametroTotem":
        return "/servicios/parametros/consultarParametrosTotem";
      case "obtenerRangoFestivosAnual":
        return "/servicios/parametros/obtenerRangoFestivosAnual";
      case "crearFestivo":
        return "/servicios/parametros/crearFestivo";
      case "eliminarFestivo":
        return "/servicios/parametros/eliminarFestivo";
      case "eliminarParametroTotem":
        return "/servicios/parametros/eliminarParametroTotem";
      case "consultarMotivos":
        return "/servicios/motivoConsultaUac/consultarParametroMotivosConsulta";
      case "crearMotivo":
        return "/servicios/motivoConsultaUac";
      case "actualizarMotivo":
        return "/servicios/motivoConsultaUac";
      case "consultarMotivoUAC":
        return "/servicios/motivoConsultaUac";		
      case "motivosTramiteUAC":
        return "/servicios/motivosTramitesUac";
      case "sedesTramiteUAC":
        return "/servicios/serviciosTramites";
      default:
        break;
    }
  }

  /**
   * provider para los servicios funcionario
   * @param serviceProvider: string {description}
   * @return void
   */
  private getProviderFuncionario(serviceProvider: string): string {
    switch (serviceProvider) {
      case "CargueList":
        return "/cargue/all";
      case "CargueExcel":
        return "/cargue/import";
      case "CargueLogErrores":
        return "/cargue/errores";
      case "CargueLogErroresExport":
        return "/cargue/errores/export";
      case "ObtenerDominio":
        return "/servicios/detalledominio";
      case "guardarInformacionFuncionario":
        return "/servicios/funcionario/guardarInformacionFuncionario";
      case "reporteUsoBicicleta":
        return "/servicios/reportes/reporteUsoBicicleta";
      case "reporteCompensacionBicicleta":
        return "/servicios/reportes/reporteCompensacionBicicleta";
      case "ObtenerDependencias":
        return "/servicios/dependencia";
      case "consultarInformacionFuncionario":
        return "/servicios/funcionario/consultarInformacionFuncionario";
      case "guardarInformacionCompensaciones":
        return "/servicios/plancompensacion/guardarInformacionCompensaciones";
      case "consultarPlanesDeCompensacion":
        return "/servicios/plancompensacion/consultarPlanesDeCompensacion";
      case "consultarCompensacion":
        return "/servicios/plancompensacion";
      case "consultarTurnosCompensacion":
        return "/servicios/turno";
      case "ObtenerFuncionario":
        return "/servicios/funcionario";
      case "consultarJefes":
        return "/servicios/dependencia/consultarJefes";
      case "guardarJefe":
        return "/servicios/dependencia/guardarJefe";
      case "obtenerJefe":
        return "/servicios/dependencia/obtenerJefe";
      case "planCompensacionActual":
        return "/servicios/plancompensacion/planCompensacionActual";
      case "validarInscripcionPlanActual":
        return "/servicios/configuracioncompensacion/validarInscripcionPlanActual";
      case "inscripcionCompensacion":
        return "/servicios/configuracioncompensacion";
      case "editarInscripcionCompensacion":
        return "/servicios/configuracioncompensacion/editarInscripcionPlanActual";
      case "validarTokenFuncionarioCargueDocumento":
        return "/servicios/funcionario/validarTokenFuncionarioCargueDocumento";
      case "reporteDetalleFuncionario":
        return "/servicios/reportes/reporteDetalleFuncionario";
      case "consultarCompensaciones":
        return "/servicios/plancompensacion/consultarCompensaciones";
      case "exportarCompensaciones":
        return "/servicios/reportes/exportarCompensaciones";
      case "notificarCompensaciones":
        return "/servicios/plancompensacion/notificarCompensaciones";
      case "consultarDependencia":
        return "/servicios/dependencia/consultarDependencia";
      case "editarEstadoInscripcionPlan":
        return "/servicios/configuracioncompensacion/editarEstadoInscripcionPlan";
      case "getInscripcionesPorDependencia":
        return "/servicios/configuracioncompensacion/getInscripcionesPorDependencia";
      case "consultarParametrosCargueDocumento":
        return "/servicios/parametros/consultarParametrosCargueDocumento";
      case "reporteAuditoriaFuncionario":
        return "/servicios/reportes/reporteAuditoriaFuncionario";
      case "consutarIncentivoFuncionarios":
        return "/servicios/compensacionbicicleta/consutarIncentivoFuncionarios";
      case "consultarListaDependencia":
        return "/servicios/dependencia/consultarListaDependencia";
      case "compensacionPorFuncionario":
        return "/servicios/compensacionbicicleta/compensacionPorFuncionario";
      case "crearSolicitudAjuste":
        return "/servicios/solicitudajuste/crearSolicitudAjuste";
      case "getSolicitudesPorDependencia":
        return "/servicios/solicitudajuste/getSolicitudesPorDependencia";
      case "validarSolicitudAjustePlanActual":
        return "/servicios/solicitudajuste/validarSolicitudAjustePlanActual";
      case "realizarAjusteCompensacion":
        return "/servicios/configuracioncompensacion/realizarAjusteCompensacion";
      case "validarCodigoFuncionarioBicicleta":
        return "/servicios/funcionario/validarCodigoFuncionarioBicicleta";
      case "listaArchivosSolicitud":
        return "/servicios/archivosolicitud";
      case "descargarSoporte":
        return "/servicios/archivosolicitud/descargarSoporte";
      case "consultarVehiculos":
        return "/servicios/vehiculofuncionario";
      case "actualizarVehiculos":
        return "/servicios/vehiculofuncionario";
      case "gestionarVehiculos":
        return "/servicios/vehiculofuncionario/gestionarVehiculos";
      case "enviarCorreoElectronicoCargueFotoARL":
        return "/servicios/funcionario/enviarCorreoElectronicoCargueFotoARL";
      case "registrarIngresoFuncionarioBicicleta":
        return "/servicios/hisingresobicicleta/registrarIngresoFuncionarioBicicleta";
      case "registrarSalidaFuncionarioBicicleta":
        return "/servicios/hisingresobicicleta/registrarSalidaFuncionarioBicicleta";
      case "solicitarCompensacion":
        return "/servicios/compensacionbicicleta/solicitarCompensacion";
      case "aprobarCompensacion":
        return "/servicios/compensacionbicicleta/aprobarCompensacion";
      case "generarStickerBicicleta":
        return "/servicios/funcionario/generarStickerBicicleta";
      case "actualizarPorcentajeVehiculos":
        return "/servicios/funcionario/actualizarPorcentajeVehiculos";
      case "obtenerTipoVehiculo":
        return "/servicios/detalledominio?filterBy=detalleDominioPK.nombreDominio%3ALIKE%3ATipoVehiculo";
      case "crearVehiculos":
        return "/servicios/vehiculofuncionario/crearVehiculos";
      case "consultarJefesAsignados":
        return "/servicios/dependencia/consultarJefesAsignados";
      default:
        break;
    }
  }

  /**
   * provider para los servicios transversale
   * @param serviceProvider: string {description}
   * @return void
   */
  private getProviderTransversal(serviceProvider: string): string {
    switch (serviceProvider) {
      case "CargueList":
        return "/cargue/all";
      case "CargueExcel":
        return "/cargue/import";
      case "CargueLogErrores":
        return "/cargue/errores";
      case "CargueLogErroresExport":
        return "/cargue/errores/export";
      case "ConsultaFuncionario":
        return "/servicios/funcionario/consultarFuncionarios";
      case "consultarDominios":
        return "/servicios/detalledominio/consultarDominios";
      case "consultarFestivos":
        return "/servicios/parametros/obtenerFestivos";
      case "consultarParametros":
        return "/servicios/parametros/consultarParametros";
      case "consultarFucionarioSIA3":
        return "/servicios/funcionario/consultarFucionarioSIA3";
      case "ObtenerDominio":
        return "/servicios/detalledominio";
      case "ValidarCaptcha":
        return "/servicio/init/validarecap";
      case "ObtenerParametros":
        return "/servicios/parametros";
      case "ConsultarParametrosAccesibilidad":
        return "recursoswebseguridad/accesibilidad/propiedadesAccUser/obtenerPropAccesibilidad";
      case "PersistirParametrosAccesibilidad":
        return "recursoswebseguridad/accesibilidad/AlmacenarPropiedadesAccUser/almacenarPropAccesibilidad";
      case "parametroPorNombre":
        return "/servicios/parametros/consultarParametrosPorNombre";
      default:
        return "";
    }
  }

  /**
   * concatena en la URL los paramteros con %26
   * @param queryParams
   */
  private getPathParams(queryParams: [string, string][]): string {
    let paramResponse = "";
    for (const param of queryParams) {
      paramResponse = paramResponse + param[0] + "=" + param[1] + "%26";
    }
    const urilenght = paramResponse.length;
    return "?" + paramResponse.substring(0, urilenght - 3);
  }

  /**
   * Concatena en la url los parametros con &
   * @param queryParams
   */
  private getQueryParams(queryParams: [string, string][]): string {
    let paramRes = "";
    for (const param of queryParams) {
      paramRes = paramRes + param[0] + "=" + param[1] + "&";
    }
    const urilenght = paramRes.length;
    return "?" + paramRes.substring(0, urilenght - 1);
  }

  public encodeURI(uri: string): string {
    return encodeURIComponent(uri);
  }
  public decodeURI(uri: string): string {
    return decodeURIComponent(uri);
  }
}
